/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useMemo } from 'react'
// material
// 3d
import { ReactComponent as ThreeDAngry } from 'assets/emojis/3d/angry.svg'
import { ReactComponent as ThreeDCurious } from 'assets/emojis/3d/curious.svg'
import { ReactComponent as ThreeDDownvote } from 'assets/emojis/3d/downvote.svg'
import { ReactComponent as ThreeDFunny } from 'assets/emojis/3d/funny.svg'
import { ReactComponent as ThreeDLove } from 'assets/emojis/3d/love.svg'
import { ReactComponent as ThreeDSad } from 'assets/emojis/3d/sad.svg'
import { ReactComponent as ThreeDThoughtful } from 'assets/emojis/3d/thoughtful.svg'
import { ReactComponent as ThreeDUpvote } from 'assets/emojis/3d/upvote.svg'
// flat
import { ReactComponent as FlatAngry } from 'assets/emojis/flat/angry.svg'
import { ReactComponent as FlatCurious } from 'assets/emojis/flat/curious.svg'
import { ReactComponent as FlatDownvote } from 'assets/emojis/flat/downvote.svg'
import { ReactComponent as FlatFunny } from 'assets/emojis/flat/funny.svg'
import { ReactComponent as FlatLove } from 'assets/emojis/flat/love.svg'
import { ReactComponent as FlatSad } from 'assets/emojis/flat/sad.svg'
import { ReactComponent as FlatThoughtful } from 'assets/emojis/flat/thoughtful.svg'
import { ReactComponent as FlatUpvote } from 'assets/emojis/flat/upvote.svg'
// monochrome
import { ReactComponent as MonochromeAngry } from 'assets/emojis/monochrome/angry.svg'
import { ReactComponent as MonochromeCurious } from 'assets/emojis/monochrome/curious.svg'
import { ReactComponent as MonochromeDownvote } from 'assets/emojis/monochrome/downvote.svg'
import { ReactComponent as MonochromeFunny } from 'assets/emojis/monochrome/funny.svg'
import { ReactComponent as MonochromeLove } from 'assets/emojis/monochrome/love.svg'
import { ReactComponent as MonochromeSad } from 'assets/emojis/monochrome/sad.svg'
import { ReactComponent as MonochromeThoughtful } from 'assets/emojis/monochrome/thoughtful.svg'
import { ReactComponent as MonochromeUpvote } from 'assets/emojis/monochrome/upvote.svg'
// skeleton
import { ReactComponent as SkeletonAngry } from 'assets/emojis/skeleton/angry.svg'
import { ReactComponent as SkeletonCurious } from 'assets/emojis/skeleton/curious.svg'
import { ReactComponent as SkeletonDownvote } from 'assets/emojis/skeleton/downvote.svg'
import { ReactComponent as SkeletonFunny } from 'assets/emojis/skeleton/funny.svg'
import { ReactComponent as SkeletonLove } from 'assets/emojis/skeleton/love.svg'
import { ReactComponent as SkeletonSad } from 'assets/emojis/skeleton/sad.svg'
import { ReactComponent as SkeletonThoughtful } from 'assets/emojis/skeleton/thoughtful.svg'
import { ReactComponent as SkeletonUpvote } from 'assets/emojis/skeleton/upvote.svg'
// styles
import injectSheet from 'react-jss'
import styles from './emoji_styles'


/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: SITE THEME SECTION : COMPONENTS - EMOJI ~~~~~~~~~~ ========== */
const Emoji = injectSheet(styles)(({ size = 40, name, type = 'THREE_D', isDark = false, classes }) => {

  const emoji = useMemo(() => {
    const emojiSize  = {
      height: size,
      width: size
    }
    const emojisMap = {
      THREE_D: {
        'ANGRY': <ThreeDAngry {...emojiSize} />,
        'SHOCKED': <ThreeDCurious {...emojiSize} />,
        'DISLIKE': <ThreeDDownvote {...emojiSize} />,
        'FUNNY': <ThreeDFunny {...emojiSize} />,
        'LOVE': <ThreeDLove {...emojiSize} />,
        'SAD': <ThreeDSad {...emojiSize} />,
        'THOUGHTFUL': <ThreeDThoughtful {...emojiSize} />,
        'LIKE': <ThreeDUpvote {...emojiSize} />
      },
      FLAT: {
        'ANGRY': <FlatAngry  {...emojiSize} />,
        'SHOCKED': <FlatCurious {...emojiSize} />,
        'DISLIKE': <FlatDownvote {...emojiSize} />,
        'FUNNY': <FlatFunny {...emojiSize} />,
        'LOVE': <FlatLove {...emojiSize} />,
        'SAD': <FlatSad {...emojiSize} />,
        'THOUGHTFUL': <FlatThoughtful {...emojiSize} />,
        'LIKE': <FlatUpvote {...emojiSize} />
      },
      MONOCHROME: {
        'ANGRY': <MonochromeAngry fill={'#FFF'} {...emojiSize} />,
        'SHOCKED': <MonochromeCurious {...emojiSize} />,
        'DISLIKE': <MonochromeDownvote {...emojiSize} />,
        'FUNNY': <MonochromeFunny {...emojiSize} />,
        'LOVE': <MonochromeLove {...emojiSize} />,
        'SAD': <MonochromeSad {...emojiSize} />,
        'THOUGHTFUL': <MonochromeThoughtful {...emojiSize} />,
        'LIKE': <MonochromeUpvote {...emojiSize} />
      },
      SKELETON: {
        'ANGRY': <SkeletonAngry {...emojiSize} />,
        'SHOCKED': <SkeletonCurious {...emojiSize} />,
        'DISLIKE': <SkeletonDownvote {...emojiSize} />,
        'FUNNY': <SkeletonFunny {...emojiSize} />,
        'LOVE': <SkeletonLove {...emojiSize} />,
        'SAD': <SkeletonSad {...emojiSize} />,
        'THOUGHTFUL': <SkeletonThoughtful {...emojiSize} />,
        'LIKE': <SkeletonUpvote {...emojiSize} />
      }
    };
    return emojisMap[type][name]
  }, [name, type, size])

  return <div className={`emoji ${classes.emoji} isDark-${isDark} type-${type.toLowerCase()}`}>{emoji}</div>
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Emoji